import React from 'react';
import { MdEmail, MdPhone, MdLink } from 'react-icons/md';

function Contact({ user }) {
  const email = user?.email || 'your-email@example.com';
  // Note: These would typically come from user profile data, but hardcoding placeholders for now
  // as per standard automation tool setups until a full profile editing feature includes these fields.
  const phone = '+91 999 580 5992';
  const linkedIn = 'https://www.linkedin.com/in/raigan-a-r-44087412a/';

  return (
    <div className="contact-page">
      <div className="custom-functions-header" style={{ marginBottom: '30px' }}>
        <h1 style={{ margin: 0 }}>Contact Spider Web Team</h1>
        <p style={{ margin: '8px 0 0 0', color: 'var(--text-muted)' }}>
          Get in touch with the team or the creator.
        </p>
      </div>

      <div className="grid">
        <div className="card" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', textAlign: 'center' }}>
          <div style={{ backgroundColor: 'var(--primary)', color: 'white', padding: '16px', borderRadius: '50%', marginBottom: '20px' }}>
            <MdEmail size={40} />
          </div>
          <h2 style={{ margin: '0 0 10px 0' }}>Email Us</h2>
          <p style={{ color: 'var(--text-muted)', marginBottom: '20px' }}>
            For support, feature requests, or general inquiries.
          </p>
          <a href={`mailto:${email}`} className="btn btn-primary" style={{ textDecoration: 'none' }}>
            {email}
          </a>
        </div>

        <div className="card" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', textAlign: 'center' }}>
          <div style={{ backgroundColor: 'var(--success)', color: 'white', padding: '16px', borderRadius: '50%', marginBottom: '20px' }}>
            <MdPhone size={40} />
          </div>
          <h2 style={{ margin: '0 0 10px 0' }}>Call Us</h2>
          <p style={{ color: 'var(--text-muted)', marginBottom: '20px' }}>
            Available Mon-Fri, 9am - 5pm EST.
          </p>
          <a href={`tel:${phone}`} className="btn btn-success" style={{ textDecoration: 'none' }}>
            {phone}
          </a>
        </div>

        <div className="card" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', textAlign: 'center' }}>
          <div style={{ backgroundColor: '#0077B5', color: 'white', padding: '16px', borderRadius: '50%', marginBottom: '20px' }}>
            <MdLink size={40} />
          </div>
          <h2 style={{ margin: '0 0 10px 0' }}>LinkedIn</h2>
          <p style={{ color: 'var(--text-muted)', marginBottom: '20px' }}>
            Connect with us professionally.
          </p>
          <a href={linkedIn} target="_blank" rel="noopener noreferrer" className="btn" style={{ backgroundColor: '#0077B5', color: 'white', textDecoration: 'none', border: 'none' }}>
            View Profile
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contact;
